import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'


const SocialMenu = () => {
    return (
        <Wrapper>
            <div className="social-links py-4">
                <Link to='*'><i className="fab fa-instagram"></i></Link>
                <Link to='*'><i className="fab fa-twitter"></i></Link>
                <Link to='*'><i className="fab fa-facebook"></i></Link>
                <Link to='*'><i className="fab fa-youtube"></i></Link>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.section`
       .social-links i{
           font-size: 20px;
           padding:5px;
           margin: 5px;
           border: 2px solid #fff;
           color: #fff;
           border-radius: 50%;
           height: 35px;
           width: 35px;
           text-align: center;
           transition: var(--transition);
            &:hover {
                color: var(--clr-grey-7);
            }

       }
`

export default SocialMenu
